import { createRouter, createWebHistory } from 'vue-router'
import Pages from '../views/Pages.vue'
import Editor from '../views/Editor.vue'

const routes = [
  {
    path: '/',
    name: 'Pages',
    component: Pages
  },{
    path: '/:page',
    name: 'Other',
    component: Pages
  },{
    path: '/:sub/sub',
    name: 'Sub',
    component: Pages
  },
  {
    path: '/editor',
    name: 'Editor',
    component: Editor
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
